import { SparkLineOverflow as HygraphSparkLineOverflow } from '@/lib/types';

import SparkLineOverflow from '@/components/spark-line-overflow';

import lightColorTransformer from '@/hygraph/transformers/light-color.transformer';

export default function SparkLineOverflowRenderer(
  props: HygraphSparkLineOverflow
) {
  return (
    <SparkLineOverflow
      backgroundColor={lightColorTransformer(props.backgroundColor)}
      caption={props.caption || ''}
      headline={props.headline || ''}
    />
  );
}
